import React, { useEffect, useState, useMemo } from "react";
import { ApplicationRoles } from "./api-authorization/ApiAuthorizationConstants";

import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Table from "react-bootstrap/Table";
import Badge from "react-bootstrap/Badge";

import adminService from '../services/AdminService';
import ageGradeCategoryService from '../services/AdminServices/AgeGradeCategoryService';
import authorizeService from './api-authorization/AuthorizeService';

import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";

import { HubConnectionBuilder } from "@microsoft/signalr";

import UserDetailsModal from "./Modals/UserDetailsModal";
import CreateUserModal from "./Modals/Admin/CreateUserModal";

import ToggleButton from "react-bootstrap/ToggleButton";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";

const Home = (props) => {
    const typaheadRef = React.createRef();

    const [users, setUsers] = useState(null);
    const [sortConfig, setSortConfig] = React.useState({
        key: "name",
        direction: "ascending",
    });
    const [search, setSearch] = useState(null);
    const [loading, setLoading] = useState(true);

    const [showDetailsModal, setShowDetailsModal] = React.useState(false);
    const [showCreateModal, setShowCreateModal] = React.useState(false);
    const [selectedUserId, setSelectedUserId] = React.useState(null);

    const [userRoles, setUserRoles] = useState(null);
    //   const [checked, setChecked] = useState(false);
    const [activatedFilter, setActivatedFilter] = useState(true);
    const [roleNameFilter, setRoleNameFilter] = useState(null);

    useEffect(() => {
        if (!userRoles) {
            adminService.getRoles().then((roles) => {
                setUserRoles(roles);
            });
        }
    }, [userRoles]);

    useEffect(() => {
        if (!users) {
            adminService.getUsersList().then((response) => {
                setUsers(response);
                setLoading(false);
            });
        }
    }, [users]);

    const hideShowDetailsModal = () => {
        adminService.getUsersList().then((users) => {
            setUsers(users);
        });
        setShowDetailsModal(false);
        setSelectedUserId(null);
    };

    const hideShowCreateModal = (success, userId) => {
        setShowCreateModal(false);
        if (success) {
            setSelectedUserId(userId);
            setShowDetailsModal(true);
            adminService.getUsersList().then((users) => {
                setUsers(users);
            });
        }
    };

    const renderUserDetailsModal = () => {
        if (selectedUserId) {
            return (
                <UserDetailsModal
                    onHide={hideShowDetailsModal}
                    show={showDetailsModal}
                    userId={selectedUserId}
                ></UserDetailsModal>
            );
        } else return <></>;
    };

    const renderCreateUserModal = () => {
        return (
            <CreateUserModal
                onHide={hideShowCreateModal}
                show={showCreateModal}
                roles={userRoles}
            ></CreateUserModal>
        );
    };

    const setSort = (key) => {
        let direction = "ascending";
        if (
            sortConfig &&
            sortConfig.key === key &&
            sortConfig.direction === "ascending"
        ) {
            direction = "descending";
        }
        setSortConfig({ key, direction });
    };

    const renderDropdown = (users, setSearch) => {
        if (users) {
            let typaheadNames = users.map((x) => {
                return { id: x.userId, label: `${x.firstname} ${x.lastname}` };
            });

            return (
                <Typeahead
                    id="my-typeahead-id"
                    ref={typaheadRef}
                    clearButton
                    multiple
                    onChange={(selected) => {
                        if (selected && selected.length > 0) {
                            setSearch(selected.map((x) => x.id));
                        } else {
                            setSearch(null);
                        }
                    }}
                    options={typaheadNames}
                    placeholder="Type to search users"
                />
            );
        }
        return <></>;
    };

    const renderTable = (users) => {
        let content = <></>;
        if (loading) {
            content = <tr className="p-2">
                <td colSpan="5" className="text-center">
                    Loading...
                </td>
            </tr>;
        } else if (!users || users.length == 0) {
            content = <tr className="p-2">
                <td colSpan="5" className="text-center">
                    No Users
                </td>
            </tr>;
        } else {
            content = users.map((x) => {
                return (
                    <tr key={x.userId}>
                        <td>
                            {x.firstname} {x.lastname}
                        </td>
                        <td>{x.email}</td>
                        <td>{x.activated ? "True" : "False"}</td>
                        <td>{x.roleName}</td>
                        <td className="fit">
                            <Button
                                size="sm"
                                variant="outline-info"
                                className="ml-2"
                                onClick={async (clickInfo) => {
                                    setSelectedUserId(x.userId);
                                    setShowDetailsModal(true);
                                }}
                            >
                                Details
                            </Button>
                        </td>
                    </tr>
                );
            });
        }

        let homeTeamNameSortClass =
            sortConfig && sortConfig.key == "homeTeamName"
                ? sortConfig.direction == "ascending"
                    ? "asc"
                    : "desc"
                : "";
        //let awayTeamNameSortClass = sortConfig && sortConfig.key == 'awayTeamName' ? (sortConfig.direction == 'ascending' ? 'asc' : 'desc') : '';
        //let kickoffSortClass = sortConfig && sortConfig.key == 'kickoff' ? (sortConfig.direction == 'ascending' ? 'asc' : 'desc') : '';
        //let competitionNameSortClass = sortConfig && sortConfig.key == 'competitionName' ? (sortConfig.direction == 'ascending' ? 'asc' : 'desc') : '';

        //let example = (
        //  <th
        //    className={"sortable " + homeTeamNameSortClass}
        //    onClick={() => setSort("homeTeamName")}
        //  >
        //    Home Team
        //    <div></div>
        //  </th>
        //);

        return (
            <>
                <div
                    style={{
                        overflowY: "scroll",
                        overflowX: "scroll",
                        whiteSpace: "nowrap",
                        maxHeight: "calc(100vh - 180px)",
                    }}
                >
                    <Table striped bordered hover className="react-bootstrap-table">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Activated</th>
                                <th>Role</th>
                                <th className="fit">Actions</th>
                            </tr>
                        </thead>
                        <tbody>{content}</tbody>
                    </Table>
                </div>
            </>
        );
    };

    let getFilteredUsers = (users, search) => {
        if (search && search.length > 0) {
            return users.filter((x) => {
                return search.some((y) => x.userId == y);
            });
        }
        return users;
    };
    let getFilteredRole = (users, roleNameValue) => {
        if (roleNameValue && roleNameValue.length > 0) {
            return users.filter((x) => {
                return roleNameValue.some((y) => x.roleName == y);
            });
        }
        return users;
    };
    let getFilteredActivated = (users, activatedValue) => {
        if (activatedValue !== null) {
            return users.filter((x) => x.activated == activatedValue);
        }
        return users;
    };
    const filteredUsers = useMemo(() => {
        if(users) {
        let showUsers = [...users]
        showUsers = getFilteredUsers(showUsers, search);
        showUsers = getFilteredRole(showUsers, roleNameFilter);
        showUsers = getFilteredActivated(showUsers, activatedFilter);
        if (showUsers) {
            if (sortConfig) {
                showUsers.sort((a, b) => {
                    if (sortConfig.key == "kickoff") {
                        if (a["date"] < b["date"]) {
                            return sortConfig.direction === "ascending" ? -1 : 1;
                        }
                        if (a["date"] > b["date"]) {
                            return sortConfig.direction === "ascending" ? 1 : -1;
                        } else {
                            if (a["kickoffTime"] < b["kickoffTime"]) {
                                return sortConfig.direction === "ascending" ? -1 : 1;
                            }
                            if (a["kickoffTime"] > b["kickoffTime"]) {
                                return sortConfig.direction === "ascending" ? 1 : -1;
                            }
                        }
                    } else {
                        if (a[sortConfig.key] < b[sortConfig.key]) {
                            return sortConfig.direction === "ascending" ? -1 : 1;
                        }
                        if (a[sortConfig.key] > b[sortConfig.key]) {
                            return sortConfig.direction === "ascending" ? 1 : -1;
                        }
                    }
                    return 0;
                });
            }
            return showUsers;
        }
        return showUsers
    } else {
        return [];
    }
    }, [users, search, sortConfig, roleNameFilter, activatedFilter]);

    const renderActivated = (users) => {
        if (users) {

            return (
                <Button
                    className="ml-2 float-right my-1"
                    variant={activatedFilter ? "outline-success" : "outline-danger"}
                    name="radio"
                    value={activatedFilter}
                    onClick={(e) => {
                        setActivatedFilter((current) => !current)
                    }
                    }
                >
                    {activatedFilter ? "Activated" : "Deactivated"}
                </Button>
            );
        }
        return <></>;
    };

    const renderFilterRole = (users) => {
        if (users) {
            const roles = ["Manager", "Watcher", "Admin", "Uploader"];
            let typaheadNames = roles.map((x) => {
                return { label: `${x}` };
            });
            return (
                <Typeahead
                    className="ml-2 float-right my-1"
                    id="my-typeahead-id1"
                    ref={typaheadRef}
                    clearButton
                    multiple
                    onChange={(selected) => {
                        if (selected && selected.length > 0) {
                            setRoleNameFilter(selected.map((x) => x.label));
                        } else {
                            setRoleNameFilter(null);
                        }
                    }}
                    options={typaheadNames}
                    placeholder="Type to search role"
                    style={{ maxWidth: 300 }}
                />
            );
        }
        return <></>;
    };
    let title = <h1 id="tabelLabel">Users</h1>;
    let contents = renderTable(filteredUsers);

    let userDetailsModal = renderUserDetailsModal();
    let createUserModal = renderCreateUserModal();

    let dropdown = renderDropdown(users, setSearch);
    let activated = renderActivated(users);
    let filterRole = renderFilterRole(users);

    return (
        <div>
            <Row className="mr-0">
                <Col>{title}</Col>
            </Row>
            <Row className="mb-2 mr-0">
                <Col sm="6" lg="4">
                    {dropdown}
                </Col>
                <Col sm="6" lg="8" style={{ alignItems: "center" }}>
                    <Button
                        variant="outline-primary"
                        className="ml-2 float-right my-1"
                        onClick={(clickInfo) => {
                            setShowCreateModal(true);
                        }}
                    >
                        Create user
                    </Button>

                    {activated}
                    {filterRole}
                </Col>
            </Row>

            {contents}

            {userDetailsModal}
            {createUserModal}
        </div>
    );
};

Home.displayName = Home.name;

export default Home;
